import VueSlider from 'vue-slider-component';
import Debug from '@/util/debug';
import * as constants from '@/util/constants';

const debug = Debug('interval-slider');

export default {
  components: {
    VueSlider,
  },
  props: {
    intervals: {
      validator: value => value.reduce((acc, val) => (acc && ('from' in val) && ('to' in val)), true),
    },
    selected: {
      validator: value => ('from' in value) && ('to' in value),
    },
  },
  computed: {
    stepsCount: function computeStepsCount() {
      return this.intervals.length;
    },
    selectedIndexes: function computeSelectedInexes() {
      return this.rangeToIndexes(this.selected.from, this.selected.to);
    },
  },
  methods: {
    rangeToIndexes(from, to) {
      let idxFrom = null;
      let idxTo = null;
      this.intervals.forEach((interval, index) => {
        if (interval.from === from) {
          idxFrom = index;
        }

        if (interval.to === to) {
          idxTo = index + 1;
        }
      });

      // If provided age range does not exist - update it to correct values
      if (idxFrom === null || idxTo === null) {
        if (idxFrom === null) idxFrom = 0;
        if (idxTo === null) idxTo = this.intervals.length;
        this.onCallback([idxFrom, idxTo]);
      }

      return [idxFrom, idxTo];
    },
    onCallback(indexes) {
      let idxFrom = indexes[0];
      let idxTo = indexes[1];

      // Prevent overlaps
      if (idxFrom === idxTo) {
        if (idxFrom === 0) {
          idxTo += 1;
        } else {
          idxFrom -= 1;
        }
      }

      const from = this.intervals[idxFrom].from;
      const to = this.intervals[idxTo - 1].to;

      debug.info('selected from %d to %d', from, to);
      this.$emit('update:selected', { from, to });
    },
    formatLabel(index) {
      // First time after element is mounted this is called before refs are linked
      // As soon as refs are set we will receive another call to formatLabel
      // so client won't notice the 'bad' initial value
      if (!this.$refs.vueslider) {
        return '?';
      }

      // We do not care about indexes that are not selected
      if (this.$refs.vueslider.currentValue.slice(0, 2).indexOf(index) === -1) {
        return '?';
      }

      const lowerBoundIndex = this.$refs.vueslider.currentValue[0];
      const needLowerBound = lowerBoundIndex === index;

      try {
        let value = this.intervals[needLowerBound ? index : index - 1][needLowerBound ? 'from' : 'to'];
        if (index === this.stepsCount && value === constants.AGE_BOUNDS_MAX) {
          value = `${value}+`;
        }
        return value;
      } catch (e) {
        // This will happen during overlaps
        return this.intervals[index - 1].to;
      }
    },
    changeInterval(e) {
      // TESTING event
      if (e.detail && e.detail.min && e.detail.max) {
        this.selected.from = e.detail.min;
        this.selected.to = e.detail.max;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/interval-slider/IntervalSlider.js